import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const MicrosoftTranslatorLogoBlueIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M737 1716q0 77 5 153t20 153l-148 5q-5-22-8-43t-3-45h-9q-66 60-147 83t-169 23q-60 0-109-18t-83-51-54-82-19-110q0-88 30-151t82-105 122-61 152-20q63 0 126 12 13 2 33 8t33 7q5 0 6-2t1-8q0-11-2-21t-2-21q0-63-18-101t-52-58-79-27-100-7q-30 0-52 4t-43 11-42 14-49 15l-24-130q35-10 66-19t61-15 63-10 70-4q80 0 144 15t111 50 70 94 25 146q0 79-4 158t-4 158zm-389 200q67 0 131-17t117-61q-3-65-4-128t-1-129q-35-11-72-16t-74-6q-46 0-95 11t-90 35-67 62-26 93q0 42 14 71t38 48 57 28 72 9zM461 596l297 298H0V128l224 224q75-52 162-77t179-25q43 0 88 5t89 17 85 29 78 42q-62 5-126 25t-124 53-110 77-84 98z" />
    </svg>
  ),
  displayName: 'MicrosoftTranslatorLogoBlueIcon',
});

export default MicrosoftTranslatorLogoBlueIcon;
